import { unwrap } from '@remote-medium/ui';
import type { InferResponseType } from 'hono/client';

import { admin } from '../../../lib/client.ts';

export type Company = InferResponseType<(typeof admin.companies)[':id']['$get'], 200>['data'];
export type CompanyRole = InferResponseType<
  (typeof admin.companies)[':id']['roles']['$get'],
  200
>['data'][number];

/**
 * Everything around a company that the company endpoint doesn't return: its
 * roles with per-stage match counts (grouped on the server) and the email
 * log.
 */
export async function loadCompanyContext(companyId: string) {
  const [roles, emailLog] = await Promise.all([
    unwrap(admin.companies[':id'].roles.$get({ param: { id: companyId } })),
    unwrap(admin['email-log'].$get({ query: { companyId } })),
  ]);
  return { roles, emailLog };
}

export type CompanyContext = Awaited<ReturnType<typeof loadCompanyContext>>;
